import { render } from "./ContinueButton.vue?vue&type=template&id=c52d5ffe&scoped=true"
import script from "./ContinueButton.vue?vue&type=script&lang=js"
export * from "./ContinueButton.vue?vue&type=script&lang=js"

import "./ContinueButton.vue?vue&type=style&index=0&id=c52d5ffe&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-c52d5ffe"

export default script